import { DateTime } from 'luxon';

import * as Types from './store/types';
import { LAST_24_HOURS_VALUE } from './constants';

export const intoDate = (date: number | Date): Date => typeof date === 'number' ? new Date(date) : date;

export const startOfDay = (date = new Date()): Date => {
    const anotherDate = new Date(date.valueOf());

    anotherDate.setHours(0, 0, 0, 0);

    return anotherDate;
};

export const endOfDay = (date = new Date()): Date => {
    const anotherDate = new Date(date.valueOf());

    anotherDate.setHours(23, 59, 59, 0);

    return anotherDate;
};

export const getInitialPeriodData = (): Partial<Types.ILoginHistoryState> => {
    const currentDate = DateTime.local();
    const days = LAST_24_HOURS_VALUE;

    return {
        period: days,
        startDate: currentDate.minus({ days }).toJSDate(),
        endDate: currentDate.toJSDate()
    };
};
